<template>
  <div>
    <h1 class="text-center">Certificates</h1>
    <router-link
      class="btn bg-green px-4 py-2 text-white rounded-full no-underline inline-block mb-2"
      to="/add-certificate"
    >
      Add New Certificate
    </router-link>
    <Table ref="myTable" :endpoint="endpoint" :tableConfig="tableConfig" />
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"
import Table from "@/components/DataTable/Table"

export default {
  components: { Table },
  data() {
    return {
      endpoint: `${siteConfig.siteURL}admin/certificates`,
      tableConfig: [
        {
          header: { textContent: "Certificate Name", sortingParam: "name" },
          classList: "w-1/3",
          path: "name",
        },
        {
          header: { textContent: "Cohort" },
          path: "/",
          formatter: c =>
            `${c.cohort_name}<br/><span class="text-xs">${c.cohort_id}</span>`,
        },
        {
          header: { textContent: "Id" },
          path: "id",
        },
        {
          header: { textContent: "Enabled" },
          path: "certificate_enabled",
        },
        {
          header: { textContent: "Created On", sortingParam: "created_on" },
          type: "date",
          path: "created_on",
        },
        {
          header: { textContent: "Updated On", sortingParam: "updated_on" },
          type: "date",
          path: "updated_on",
        },
        {
          header: { textContent: "Option" },
          path: "id",
          type: "action",
          routePath: "/edit-certificate/:id",
          actionButtonText: "Edit",
        },
      ],
    }
  },
}
</script>
